import React from 'react';
import { bool, func, oneOf, node, string } from 'prop-types';
import classNames from 'classnames';
import { Link } from '@reach/router';

import LoadingAnimation from './LoadingAnimation';


export default function Button({ active, children, className, element, getProps, shape, to, type, onClick, style, disabled, loading, test }) {
  const isDisabled = disabled || loading;
  const Root = element;
  const css = classNames(className, 'Button focus:outline-none font-sans', type, {
    'px-4 py-2 xl:px-4': type !== 'plain' && type !== 'icon',
    'rounded': shape === 'rounded',
    'text-default bg-primary hover:bg-primary-lighter': type === 'primary',
    'text-secondary hover:text-default hover:bg-list-active': type === 'secondary',
    'bg-neutral text-default hover:bg-primary': type === 'tertiary',
    'p-2 text-secondary hover:text-default hover:bg-list-active': type === 'icon',
    'p-2 text-default bg-list-active': type === 'icon' && active,
    'bg-neutral-light text-secondary cursor-not-allowed': disabled,
  });

  if (to) {
    return (
      <Link
        to={to}
        className={css}
        onClick={onClick}
        style={{ transition: 'all 0.3s', ...style }}
        getProps={getProps}
        data-test={test}
      >
        {children}
      </Link>
    );
  }

  if (loading) {
    return (
      <Root
        className={css}
        onClick={onClick}
        disabled={isDisabled}
        style={{ transition: 'all 0.3s', ...style }}
        data-test={test}
      >
        <div className="flex items-center">
          {loading && <LoadingAnimation />}
          <span>{children}</span>
        </div>
      </Root>
    );
  }

  return (
    <Root
      className={css}
      onClick={onClick}
      disabled={isDisabled}
      style={{transition: 'all 0.3s', ...style}}
      data-test={test}
    >
      <span>{children}</span>
    </Root>
  );
}

Button.propTypes = {
  element: oneOf(['button', 'div', 'span']),
  size: oneOf(['small', 'medium', 'large']),
  type: oneOf(['plain', 'primary', 'secondary', 'tertiary', 'danger', 'icon']),
  shape: oneOf(['square', 'rounded', 'pill']),
  children: node,
  loading: bool,
  disabled: bool,
  fullWidth: bool,
  getProps: func,
  onClick: func,
  className: string,
  to: string,
  test: string,
};

Button.defaultProps = {
  element: 'button',
  size: 'medium',
  type: 'primary',
  shape: 'rounded',
  loading: false,
};
